import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LegalPageLayoutComponent, LegalSection } from '../../../components/legal/legal-page-layout/legal-page-layout';

@Component({
  selector: 'app-cookie-policy',
  standalone: true,
  imports: [LegalPageLayoutComponent, RouterLink],
  templateUrl: './cookie-policy.html',
})
export class CookiePolicy {
  sections: LegalSection[] = [
    { id: 'what-are-cookies', label: 'What Are Cookies?' },
    { id: 'types-of-cookies', label: 'Types of Cookies We Use' },
    { id: 'third-party-cookies', label: 'Third-Party Cookies' },
    { id: 'consent', label: 'Consent' },
    { id: 'managing-cookies', label: 'Managing Cookies' },
    { id: 'do-not-track', label: 'Do Not Track' },
    { id: 'cookie-retention', label: 'Cookie Retention' },
    { id: 'updates', label: 'Updates to Our Use of Cookies' },
    { id: 'further-information', label: 'Further Information' },
  ];
}
